import { Block } from '../../factories/types';
import { BrightwayByTheNumers } from './brightway-by-the-numbers/brightway-by-the-numbers';

export const UniqueComponent: Block<'uniqueComponent'> = ({ data }) => {
	const { type } = data.fields;

	switch (type) {
		case 'Brightway by the numbers': {
			return <BrightwayByTheNumers />;
		}
		default: {
			return null;
		}
	}
};
